import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  standalone: true,
  selector: 'mc-notification-link',
  templateUrl: './notification-link.component.html',
  imports: [RouterLink],
})
export class NotificationLinkComponent {
  @Input() link: string;
  @Input() content: string;
  @Output() linkClick = new EventEmitter();
  onLinkClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.linkClick.emit(event);
  }
}
